import React from 'react'
import styles from './styles'
import { withStyles, Typography } from '@material-ui/core'
import AddSectionButton from '../../../course-left-side/components/sections/components/add-section-button'

const EmptyMiniCourse = props => {
  const { classes, sections, setSections } = props

  return (
    <div className={classes.container}>
      <div className={classes.entityNull}>
        <img src="/assets/empty-image.svg" alt=""></img>
      </div>
      <div>
        <Typography className={classes.header}>
          There is no <span className={classes.section}>Section</span> yet.
        </Typography>
      </div>
      <div>
        <Typography fontSize="14px" fontWeight={500} className={classes.title}>
          Add a section to start creating content.
        </Typography>
      </div>
      <div className={classes.button}>
        <AddSectionButton
          display={true}
          sections={sections}
          setSections={setSections}
        />
      </div>
    </div>
  )
}

export default withStyles(styles)(EmptyMiniCourse)
